import { render, staticRenderFns } from "./groupReservation.vue?vue&type=template&id=5bcf34f7&scoped=true"
import script from "./groupReservation.vue?vue&type=script&lang=js"
export * from "./groupReservation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcf34f7",
  null
  
)

export default component.exports